import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ExecutePortfolioRequest, NgxToastrService, PortfolioService, SubjectType } from '@app/_shared/providers';
import { PANIC_CONTROL_PAUSE_TEXT, PANIC_CONTROL_STOP_TEXT } from '@app/_shared';
import { WebApiTransactionType } from '../../../../utProto/webApiStrategyEnums_pb';
import { FailoverWarningComponent } from '../failover-warning/failover-warning.component';
import { AuthService } from '@app/modules/auth';
import { ConnectBrokerDialogComponent } from '../connect-broker-dialog/connect-broker-dialog.component';
import { ManageBrokerService } from '@app/modules/trading/modules/manage-brokers/manage-broker.service';
import { ConnectedBrokersResponse } from '@app/modules/trading/modules/manage-brokers/manage-broker.interface';
import { MixpanelService } from '@app/_shared/providers/mixpanel/mixpanel.service';
import { MIXPANEL_EVENTS } from '@app/_shared/providers/mixpanel/mixpanel.events';
import { MarketPlaceService } from '@app/modules/trading/modules/market-place/providers/market-place/market-place.service';
import { MyStrategyType } from '@app/modules/trading/modules/my-strategies/my-strategies.consts';
import { Subscription } from 'rxjs';
import { BooksSocketService } from '@app/_shared/providers/websocket/books-socket/books-socket.service';


@Component({
  selector: 'app-panic-control',
  templateUrl: './panic-control.component.html',
  styleUrls: ['./panic-control.component.scss']
})
export class PanicControlComponent implements OnInit, OnDestroy {
  PANIC_CONTROL_PAUSE_TEXT = PANIC_CONTROL_PAUSE_TEXT;
  PANIC_CONTROL_STOP_TEXT = PANIC_CONTROL_STOP_TEXT;
  isVendorLogin:boolean;
  subscriptions = new Subscription();

  constructor(
    private dialogRef: MatDialogRef<PanicControlComponent>,
    private portfolioService: PortfolioService,
    private marketplaceService: MarketPlaceService,
    private snackbar: NgxToastrService,
    private matDialog: MatDialog,
    private manageBrokerService: ManageBrokerService,
    private dialog: MatDialog,
    private mixpanel: MixpanelService,
    private booksSocketService: BooksSocketService,
  ) { }

  ngOnInit(): void {  
    this.checkVendorLogin();
    this.subscriptions.add(
      this.booksSocketService.getSubject(SubjectType.BROKER_CONNECTION_SNAPSHOT).subscribe((res: ConnectedBrokersResponse | null) => {
        this.manageBrokerService.cachedConnectedBrokers = res;
        this.checkVendorLogin();
      })
    );
  }

  checkVendorLogin() {
    this.manageBrokerService.getConnectedBrokers().subscribe((res: ConnectedBrokersResponse) => {
      this.isVendorLogin = res.data.length > 0;
    });
  }

  pauseAll() {
    // if(!this.isVendorLogin){
    //   this.dialog.open(ConnectBrokerDialogComponent, {
    //     width: '500px'
    //   });
    //   this.close();
    //   return;
    // }

    const deployedPortfolios = this.marketplaceService.portfoliosCachedByType.get(MyStrategyType.Deployed);
    const portfolioToPauseExists = deployedPortfolios?.some((portfolio)=> !(portfolio.isPublic || portfolio.terminated || portfolio.forceTerminated || portfolio.isCopyOfOriginals || portfolio.paused || portfolio.stopped));
    if(!portfolioToPauseExists){
      this.snackbar.simpleCustomToaster('No self-created strategies are currently running. Deploy a self-created strategy first to use Pause All.', false);
      this.close();
      return;
    }
    this.portfolioService.pauseAllPortfolios().subscribe((res) => {
      if (res && res.userConfirmationRequired) {
        const dialogRef = this.matDialog.open(FailoverWarningComponent, {
          width: '420px',
          height: 'auto',
          panelClass: 'FailoverWarning-dialog',
          data: {
            message: res['message'],
          },
        });
        dialogRef.afterClosed().subscribe((success) => {
          if (success) {
            this.portfolioService.pauseAllPortfolios(true).subscribe(res => {
              if (res && res['message']) {
                this.snackbar.simpleCustomToaster(res['message']);
              }
              this.mixpanel.track(MIXPANEL_EVENTS.PANIC_CONTROL, { action: 'Pause All' });
            });
          }
        })

      } else {
        this.snackbar.simpleCustomToaster(res.message);
        this.mixpanel.track(MIXPANEL_EVENTS.PANIC_CONTROL, { action: 'Pause All' });
      }
    })
    this.close();

  }

  stopAll() {
    // if(!this.isVendorLogin){
    //   this.dialog.open(ConnectBrokerDialogComponent, {
    //     width: '500px'
    //   });
    //   this.close();
    //   return;
    // }

    const deployedPortfolios = this.marketplaceService.portfoliosCachedByType.get(MyStrategyType.Deployed);
    const portfolioToStopExists = deployedPortfolios?.some((portfolio)=> !(portfolio.terminated || portfolio.forceTerminated));
    if(!portfolioToStopExists){
      this.snackbar.simpleCustomToaster('No strategies are currently running. Deploy a strategy first to use Panic Control.', false);
      this.close();
      return;
    }

    this.portfolioService.stopAllPortfolios(null, false, true, true).subscribe((res) => {
      if (res && res.userConfirmationRequired) {
        const dialogRef = this.matDialog.open(FailoverWarningComponent, {
          width: '420px',
          height: 'auto',
          panelClass: 'FailoverWarning-dialog',
          data: {
            message: res['message'],
          },
        });
        dialogRef.afterClosed().subscribe((success) => {
          if (success) {
            this.portfolioService.stopAllPortfolios(null, false, true, true).subscribe(res => {
              if (res && res['message']) {
                this.snackbar.simpleCustomToaster(res['message']);
                this.mixpanel.track(MIXPANEL_EVENTS.PANIC_CONTROL, { action: 'Stop All' });
              }
            });
          }
        })

      } else {
        this.snackbar.simpleCustomToaster(res.message);
        this.mixpanel.track(MIXPANEL_EVENTS.PANIC_CONTROL, { action: 'Stop All' });
      }
    })
    this.close();

  }

  close() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

}
